"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "dimaro-folgarida": {
    "f082d81e": [{
      "hkey": "9c9ce8db",
      "slug": "dimaro-folgarida",
      "name": "Dimaro Folgarida",
      "primary": true,
      "skipSearch": false
    }],
    "carciato": [{
      "hkey": "9c9ce8db",
      "slug": "dimaro-folgarida",
      "name": "Dimaro Folgarida",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b721cd86": [{
      "hkey": "9c9ce8db",
      "slug": "dimaro-folgarida",
      "name": "Dimaro Folgarida",
      "primary": true,
      "skipSearch": false
    }],
    "casina": [{
      "hkey": "9c9ce8db",
      "slug": "dimaro-folgarida",
      "name": "Dimaro Folgarida",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d0fc493e": [{
      "hkey": "9c9ce8db",
      "slug": "dimaro-folgarida",
      "name": "Dimaro Folgarida",
      "primary": true,
      "skipSearch": false
    }],
    "presson": [{
      "hkey": "9c9ce8db",
      "slug": "dimaro-folgarida",
      "name": "Dimaro Folgarida",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;